import { render, staticRenderFns } from "./ButtonBase.vue?vue&type=template&id=2f96b390&scoped=true&lang=pug&"
import script from "./ButtonBase.vue?vue&type=script&lang=ts&"
export * from "./ButtonBase.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonBase.vue?vue&type=style&index=0&id=2f96b390&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f96b390",
  null
  
)

export default component.exports